import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalApp.css';
//import bcrypt from "bcryptjs";

const DownloadApp = ({ API_URL }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [mobile, setMobile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleMobileChange = (e) => {
        setMobile(e.target.value);
    };

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const isAndroid = /Android/i.test(navigator.userAgent);
        setIsMobile(isAndroid);

        if (!isAndroid) {
            setErrorMessage("The app can be installed on Android devices only.");
        } else {
            setErrorMessage(null);
        }
    }, []);


    const handleDownload = async (e) => {
        e.preventDefault();

        const isAndroid = /Android/i.test(navigator.userAgent);
        if (!isAndroid) return;

        setIsLoading(true);
        setErrorMessage("");

        fetch(API_URL + '/app-builds/android', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ mobile }),
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status === 401) {
                        setErrorMessage('Unauthorized mobile number. Please WhatsApp us to get the invite.');
                    } else {
                        setErrorMessage('An error occurred. Please try after some time.');
                    }
                    setIsLoading(false);
                    throw new Error("Request failed");
                }
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = "LegalApp.apk";
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err);
                setIsLoading(false);
            });
    };


    const handleCloseError = () => {
        setErrorMessage(null);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <main style={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f9f9f9'
            }}>
                <div style={{
                    padding: '20px', /* Only the card has padding now */
                    width: '100%',
                    maxWidth: '400px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    backgroundColor: 'white'
                }}>
                    <h1 style={{ textAlign: "center" }}>Install App</h1>
                    <form onSubmit={handleDownload}>
                        <div>
                            <label htmlFor="mobile">Mobile</label>
                            <input
                                id="mobile"
                                value={mobile}
                                onChange={handleMobileChange}
                                required
                                className="form-control"
                            />
                        </div>
                        <br />
                        {!isMobile && (
                            <p style={{ textAlign: "center", color: "red" }}>
                                App can be installed on Android phones only.
                            </p>
                        )}
                        <br />

                        {isMobile && (
                            <div className="popup-buttons">
                                <button
                                    type="submit"
                                    className="submit-button"
                                    style={{ fontWeight: "bold" }}
                                    disabled={
                                        !mobile ||
                                        isLoading ||
                                        !isMobile
                                    }>
                                    {isLoading ? <div className="spinner"></div> : 'Install'}
                                </button>
                            </div>
                        )}

                        <br />
                        <p style={{ textAlign: "center", lineHeight: "20px" }}>
                            WhatsApp us at +91 92172 24586
                            <br></br>
                            to install LegalApp on your mobile.
                        </p>
                    </form>

                    {errorMessage && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Error</h3>
                                <p>{errorMessage}</p>
                                <button
                                    className="submit-popup-button"
                                    onClick={handleCloseError}
                                >OK</button>
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );

};

export default DownloadApp;
